export default "__VITE_ASSET__DDqDwAQD__"